import { GridValueFormatterParams } from "@mui/x-data-grid-pro";

const dateFormatter = ({ value }: GridValueFormatterParams) => new Date(value).toLocaleDateString('en-US');

export default dateFormatter;